import service from '@/store/services/localization-service';

const state = {
    dashBoardLocal: {},
    pageLocal: {},
    pagesLocal: {},
    getLanguages: {},
    updateLanguages: {},
    getAllPageTranslate: {},
    listTranslatePage: {},
    updateTranslatePage: {},
    createLanguage: {},
    getListTranslate:{},
    getTranslate:{},
};

const mutations = {
    SET_DASHBOARD_LOCAL: (state, dashBoardLocal) => {
        state.dashBoardLocal = dashBoardLocal;
    },
    SET_PAGE_LOCAL: (state, pageLocal) => {
        state.pageLocal = pageLocal;
    },
    SET_PAGES_LOCAL: (state, pagesLocal) => {
        state.pagesLocal = pagesLocal;
    },
    SET_LANGUAGES: (state, getLanguages) => {
        state.getLanguages = getLanguages;
    },
    SET_UPDATE_LANGUAGES: (state, updateLanguages) => {
        state.updateLanguages = updateLanguages;
    },
    SET_ALL_PAGE_TRANSLATE: (state, getAllPageTranslate) => {
        state.getAllPageTranslate = getAllPageTranslate;
    },
    SET_LIST_TRANSLATE_PAGE: (state, listTranslatePage) => {
        state.listTranslatePage = listTranslatePage;
    },
    SET_UPDATE_TRANSLATE_PAGE: (state, updateTranslatePage) => {
        state.updateTranslatePage = updateTranslatePage;
    },
    SET_CREATE_LANGUAGE: (state, createLanguage) => {
        state.createLanguage = createLanguage;
    },
    GET_LIST_TRANSLATE: (state, getListTranslate) => {
        state.getListTranslate = getListTranslate;
    },
    GET_TRANSLATE: (state, getTranslate) => {
        state.getTranslate = getTranslate;
    },
};

const actions = {
    dashBoardLocal({commit, dispatch}, params) {
        return service.dashBoardLocal(params)
            .then(({dashBoardLocal}) => {
                commit('SET_DASHBOARD_LOCAL', dashBoardLocal);
            });
    },

    async pageLocal({commit, dispatch}, params) {
        return service.pageLocal(params).then((pageLocal) => {
            commit('SET_PAGE_LOCAL', pageLocal);
        });
    },

    async pagesLocal({commit, dispatch}, params) {
        return service.pagesLocal(params).then((pagesLocal) => {
            commit('SET_PAGES_LOCAL', pagesLocal);
        });
    },

    getLanguages({commit, dispatch}, params) {
        return service.getLanguages(params)
            .then(({getLanguages}) => {
                commit('SET_LANGUAGES', getLanguages);
            });
    },
    updateLanguages({commit, dispatch}, params) {
        return service.updateLanguages(params).then((updateLanguages) => {
            commit('SET_UPDATE_LANGUAGES', updateLanguages);
        });
    },

    getAllPageTranslate({commit, dispatch}, params) {
        return service.getAllPageTranslate(params)
            .then(({getAllPageTranslate}) => {
                commit('SET_ALL_PAGE_TRANSLATE', getAllPageTranslate);
            });
    },

    getListTranslate({commit, dispatch}, params) {
        return service.getListTranslate(params)
            .then(({getListTranslate}) => {
                commit('GET_LIST_TRANSLATE', getListTranslate);
            });
    },
    getTranslate({commit, dispatch}, params) {
        return service.getTranslate(params)
            .then(({getTranslate}) => {
                commit('GET_TRANSLATE', getTranslate);
            });
    },

    listTranslatePage({commit, dispatch}, params) {
        return service.listTranslatePage(params).then((listTranslatePage) => {
            commit('SET_LIST_TRANSLATE_PAGE', listTranslatePage);
        });
    },

    updateTranslatePage({commit, dispatch}, params) {
        return service.updateTranslatePage(params).then((updateTranslatePage) => {
            commit('SET_UPDATE_TRANSLATE_PAGE', updateTranslatePage);
        });
    },

    createLanguage({commit, dispatch}, params) {
        return service.createLanguage(params).then((createLanguage) => {
            commit('SET_CREATE_LANGUAGE', createLanguage);
        });
    },
};

const getters = {
    dashBoardLocal: state => state.dashBoardLocal,
    pageLocal: state => state.pageLocal,
    pagesLocal: state => state.pagesLocal,
    getLanguages: state => state.getLanguages,
    updateLanguages: state => state.updateLanguages,
    getAllPageTranslate: state => state.getAllPageTranslate,
    listTranslatePage: state => state.listTranslatePage,
    updateTranslatePage: state => state.updateTranslatePage,
    createLanguage: state => state.createLanguage,
    getListTranslate: state => state.getListTranslate,
    getTranslate: state => state.getTranslate,

};

const localization = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
export default localization;